import React from "react";

/**
 * Segmented "resolution type" control shown when the reviewer selects a
 * resolution status. Keeps the review form's business rule (credit vs.
 * voucher vs. approved return) in one place.
 */
export default function ResolutionPicker({ form, setForm }) {
  const RESOLUTION_STATUSES = new Set([
    "credit_issued", "replacement_approved", "return_approved",
  ]);
  if (!RESOLUTION_STATUSES.has(form.status)) return null;

  return (
    <div className="bg-yellow-50 border border-yellow-500 p-3">
      <div className="label-mono mb-2">Resolution type</div>
      <div className="flex gap-1">
        <button type="button" data-testid="resolution-credit"
          onClick={() => setForm({ ...form, status: "credit_issued" })}
          className={`flex-1 px-3 py-2 text-xs uppercase tracking-widest border border-black ${
            form.status === "credit_issued" ? "bg-black text-white" : "hover:bg-zinc-100"
          }`}>
          Credit (refund $)
        </button>
        <button type="button" data-testid="resolution-replacement"
          onClick={() => setForm({ ...form, status: "replacement_approved" })}
          className={`flex-1 px-3 py-2 text-xs uppercase tracking-widest border border-black ${
            form.status === "replacement_approved" ? "bg-black text-white" : "hover:bg-zinc-100"
          }`}>
          Replacement voucher
        </button>
      </div>
      <div className="text-[10px] text-zinc-600 mt-1">
        {form.status === "replacement_approved"
          ? "We'll auto-mint a voucher that the client redeems on the next matching lead — that lead is billed at $0."
          : "We'll write a credit that reduces this client's next invoice."}
      </div>
    </div>
  );
}
